import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import styles from '../../_css/Agency.module.css';
import { font } from '../Simulation/constants';

const DeletePopUp = ({ onClose, onDelete, title = 'Deactivate confirmation', message = 'Are you sure you want to deactivate this item? This action cannot be undone.', variant = 'deactivate' }) => {
  const isPermanent = variant === 'delete';
  const confirmLabel = isPermanent ? 'Delete Permanently' : 'Deactivate';
  const confirmLoadingLabel = isPermanent ? 'Deleting...' : 'Deactivating...';

  const [loading, setLoading] = useState(false);
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const handleDelete = async () => {
    setLoading(true);
    await onDelete?.();
    setLoading(false);
  };

  const overlayStyle = {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
  };
  const modalStyle = {
    maxWidth: 400,
    width: '100%',
    background: '#ffffff',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 12,
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 32px)',
  };
  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 24px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  };
  const titleStyle = { fontSize: 20, fontWeight: 700, color: '#363636', margin: 0, fontFamily: font };
  const closeBtnStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    padding: 0,
    border: 'none',
    background: 'rgba(0, 0, 0, 0.06)',
    borderRadius: 8,
    color: '#6b6b6b',
    cursor: 'pointer',
  };
  const bodyStyle = { padding: '20px 22px', overflow: 'auto', flex: 1, background: '#ffffff' };
  const footerStyle = {
    display: 'flex',
    gap: 12,
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    background: '#fafafa',
    borderRadius: '0 0 12px 12px',
  };
  const cancelBtnStyle = {
    padding: '10px 18px',
    borderRadius: 10,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    background: '#ffffff',
    color: '#363636',
    fontSize: 14,
    fontWeight: 600,
    cursor: loading ? 'not-allowed' : 'pointer',
    fontFamily: font,
    opacity: loading ? 0.7 : 1,
  };
  const deleteBtnStyle = {
    padding: '10px 20px',
    borderRadius: 10,
    border: 'none',
    background: 'linear-gradient(135deg, #ff4b4f, #dc2626)',
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    cursor: loading ? 'not-allowed' : 'pointer',
    fontFamily: font,
    boxShadow: '0 4px 16px rgba(255, 75, 79, 0.25)',
    opacity: loading ? 0.7 : 1,
  };
  const alertIconBg = { background: 'rgba(255, 75, 79, 0.12)', color: '#ff4b4f' };
  const messageColor = { color: '#5a5a5a', fontFamily: font };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-labelledby="delete-modal-title" style={overlayStyle}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={modalStyle}>
        <div style={headerStyle}>
          <h2 id="delete-modal-title" style={titleStyle}>{title}</h2>
          <button type="button" onClick={onClose} style={closeBtnStyle} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        <div style={bodyStyle}>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={{
              flexShrink: 0,
              width: 44,
              height: 44,
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ...alertIconBg,
            }}>
              <AlertTriangle className="w-6 h-6" />
            </div>
            <p style={{ margin: 0, fontSize: '0.9375rem', lineHeight: 1.5, ...messageColor }}>
              {message}
            </p>
          </div>
        </div>

        <div style={footerStyle}>
          <button type="button" onClick={onClose} style={cancelBtnStyle} disabled={loading}>
            Cancel
          </button>
          <button  type="button" onClick={handleDelete} style={deleteBtnStyle} disabled={loading}>
            {loading ? confirmLoadingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopUp;
